// extracted by mini-css-extract-plugin
export default {"trigger":"RowActionsMenu_trigger__1qZ1F","menu":"RowActionsMenu_menu__AWUI2","item":"RowActionsMenu_item__ZC6U5","itemDanger":"RowActionsMenu_itemDanger__uBzZr"};